import styles from "./styles.scss";
import { Heading } from "../typography";
import IconArrowForward from "../../assets/icons/icon-arrow_forward.svg";

const StartChatBanner = () => (
  <div className={styles.startChatBanner}>
    <Heading style={{ maxWidth: "60%" }}>Começar uma conversa</Heading>
    <IconArrowForward className={styles.arrow} />
  </div>
);

export default StartChatBanner;



// WEBPACK FOOTER //
// ./components/start-chat-banner/index.js